import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Control3d from './components/Control3d';

ReactDOM.render(
	<>
		<Control3d />
		<App />
	</>,
	document.getElementById('root')
);
